module.exports = __webpack_public_path__ + "static/img/成五-顏勝一.e3bc2a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/成五-顏勝一.jpg
// module id = tQSM
// module chunks = 1